import { combineReducers } from 'redux'
import commonDucks from './commonDucks'
import commonLogDucks from './commonLogDucks'
import settingDucks from './settingDucks'
import userDucks from './userDucks'
import warehouseDucks from './warehouseDucks'
import supplierDucks from './supplierDucks'
import rateDucks from './rateDucks'
import transportationDucks from './transportationDucks'
import productDucks from './productDucks'
import poupDucks from './poupDucks'
import purchasesRequestDucks from './purchasesRequestDucks'
import requestShareDucks from './requestShareDucks'
import orderDucks from './orderDucks'
import notificationDucks from './notificationDucks'

import categorieDucks from './categorieDucks'
import containerDucks from './containerDucks'
import requestPaymentDucks from './requestPaymentDucks'
import paymentOrderDucks from './paymentOrderDucks'

import currencyProviderDucks from './currencyProviderDucks'
import transProviderDucks from './transProviderDucks'
import taxProviderDucks from './taxProviderDucks'
import productGroupDucks from './productGroupDucks'
import searchRequestDucks from './searchRequestDucks'
import productPricingDucks from './productPricingDucks'
import reportDucks from './reportDucks'
import balanceOfdebtDucks from './balanceOfdebtDucks'
import menuDucks from './menuDucks'
import priceCategorieDucks from './priceCategorieDucks'
import auditDucks from './auditDucks'

const rootReducer = combineReducers({
  common: commonDucks,
  commonLog: commonLogDucks,
  setting: settingDucks,
  user: userDucks,
  warehouse: warehouseDucks,
  supplier: supplierDucks,
  rate: rateDucks,
  transportation: transportationDucks,
  product: productDucks,
  poup: poupDucks,
  purchasesRequest: purchasesRequestDucks,
  requestShare: requestShareDucks,
  order: orderDucks,
  notification: notificationDucks,
  categorie: categorieDucks,
  container: containerDucks,
  requestPayment: requestPaymentDucks,
  paymentOrder: paymentOrderDucks,
  currencyProvider: currencyProviderDucks,
  transProvider: transProviderDucks,
  taxProvider: taxProviderDucks,
  productGroup: productGroupDucks,
  searchRequest: searchRequestDucks,
  productPricing: productPricingDucks,
  report: reportDucks,
  balanceOfdebt: balanceOfdebtDucks,
  menu: menuDucks,
  priceCategorie: priceCategorieDucks,
  audit: auditDucks,
})

export default rootReducer
